import ValidationHelper from 'legacy/lut/classes/helpers/partner360/ValidationHelper'
import { TRANSLATION_KEYS as tr } from 'legacy/lut/components/widgets/public/partner360/actionsPlan/keyInitiatives/translations'
import { useAppDispatch } from 'legacy/lut/hooks/useAppDispatch'
import { FC, useCallback, useEffect } from 'react'

import { FormNumberInput, updateInvalidData } from 'cng-common/features/form'
import { ValidationType } from 'cng-common/features/form/configs'
import { useSafetyTranslation } from 'cng-common/features/translations'
import { isValidKeyInitiativeFundingAmount } from 'partner360/features/keyInitiativeEditor/lib/keyInitiativeMdfFunding'

interface IInvestmentSumProps {
  initialValue?: number
  className?: string
  formKey: string
  isDisabled?: boolean
  label?: string
  placeholder?: string
  isPositiveRequired?: boolean
}

export const InvestmentSum: FC<IInvestmentSumProps> = ({
  initialValue = 0,
  className,
  formKey,
  isDisabled,
  label,
  placeholder,
  isPositiveRequired = false,
}) => {
  const dispatch = useAppDispatch()
  const t = useSafetyTranslation()
  const validatePositiveAmount = useCallback(
    (value: number | null) =>
      isValidKeyInitiativeFundingAmount(value)
        ? ''
        : t(tr.keyInitiativeEditor.investmentFieldGroup.investmentSumPositiveRequired),
    [t]
  )

  useEffect(() => {
    return () => {
      dispatch(
        updateInvalidData({
          key: formKey,
          field: 'hpInvestmentSum',
          validationMessage: '',
        })
      )
    }
  }, [dispatch, formKey])

  return (
    <div className={className}>
      <FormNumberInput
        isRequired
        isDisabled={isDisabled}
        formKey={formKey}
        field="hpInvestmentSum"
        defaultValue={initialValue}
        onValidate={
          isPositiveRequired ? validatePositiveAmount : ValidationHelper.checkNullableNumberRequired
        }
        validationType={ValidationType.ONCHANGE}
        label={label}
        placeholder={placeholder}
      />
    </div>
  )
}
